export default "__VITE_ASSET__DcVl4NI9__"